// React
import React, { useEffect, useRef, useState } from 'react'
import classNames from 'classnames'
// Material UI
import { ButtonBase, FormControlLabel, Switch } from '@material-ui/core'
// Components
import CustomLoader from '../custom-loader'
// Styles
import useStyles from './CustomSwitch.styles'
// Conts
import Colors from '../../../constants/Colors'
import MuiColors from '../../../constants/muiColors'

const CustomSwitch = ({
  classes,
  checked,
  disabled,
  isLoading,
  label = '',
  loaderSize,
  onClick = () => {},
  onChange = () => {},
  value,
  invertColors = false,
}) => {
  const [primaryColor, setPrimaryColor] = useState(Colors.PRIMARY_COLOR)
  const [secondaryColor, setSecondaryColor] = useState(
    Colors.SECONDARY_FONT_COLOR,
  )

  const componentClasses = useStyles({
    checked,
    label,
    secondaryColor,
    primaryColor,
  })

  const [isLoadingLocal, setIsLoadingLocal] = useState(isLoading)
  const _isMounted = useRef(true) // Initial value _isMounted = true

  useEffect(() => {
    setPrimaryColor(
      invertColors ? Colors.SECONDARY_FONT_COLOR : Colors.PRIMARY_COLOR,
    )
    setSecondaryColor(
      invertColors ? Colors.PRIMARY_COLOR : Colors.SECONDARY_FONT_COLOR,
    )
  }, [invertColors])

  useEffect(() => {
    setIsLoadingLocal(isLoading)
  }, [isLoading])

  useEffect(() => {
    return () => {
      // ComponentWillUnmount
      _isMounted.current = false
    }
  }, [])

  return (
    <ButtonBase
      disableRipple
      classes={{
        root: classNames(componentClasses.root, classes.root),
      }}
    >
      <CustomLoader invisible open={isLoadingLocal} size={loaderSize} />
      <FormControlLabel
        classes={{
          root: classNames(
            componentClasses.formControlLabelRoot,
            classes.formControlLabelRoot,
          ),
          label: classNames(componentClasses.label, classes.label),
        }}
        control={
          <Switch
            classes={{
              root: classNames(componentClasses.switchRoot, classes.switchRoot),
              switchBase: classNames(componentClasses.control, classes.control),
              checked: classNames(
                componentClasses.controlChecked,
                classes.controlChecked,
              ),
              thumb: classNames(
                componentClasses.switchThumb,
                classes.switchThumb,
              ),
              track: classNames(
                componentClasses.controlTrack,
                classes.controlTrack,
              ),
            }}
            checked={checked}
            color={invertColors ? MuiColors.SECONDARY : MuiColors.PRIMARY}
            disabled={disabled}
            onClick={onClick}
            value={value}
          />
        }
        label={label}
        onChange={async e => {
          try {
            setIsLoadingLocal(true)
            await onChange(e)
          } catch (ex) {
            console.error(ex)
          }

          if (_isMounted.current) {
            setIsLoadingLocal(false)
          }
        }}
        value={value}
      />
    </ButtonBase>
  )
}

CustomSwitch.defaultProps = {
  classes: {},
  checked: false,
  disabled: false,
  isLoading: false,
  loaderSize: 24,
  value: false,
}

export default CustomSwitch
